import { AnimatePresence, motion } from "framer-motion";
import FileExtension from "../FileExtension";
import { Spinner } from "../LoadingIndicators/Spinner";

type UploadProgressProps = {
  assets: {
    id: string;
    name: string;
    progress: number;
  }[];
};

function UploadProgress({ assets }: UploadProgressProps) {
  return (
    <div className="w-full rounded-lg overflow-hidden border border-gray-400 border-solid">
      <div className="flex items-center justify-between p-6 bg-gradient-to-r from-blue-500 to-purple-600">
        <h2 className="text-2xl font-bold text-white flex items-center">
          Uploading Files
        </h2>
      </div>

      <div className="p-6">
        <div className="w-full space-y-4">
          <AnimatePresence mode="wait">
            {assets.map((asset) => (
              <motion.div
                key={asset.id}
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -10 }}
                className="p-4 bg-white border border-gray-400 rounded-lg shadow-sm"
              >
                <div className="flex items-center justify-between">
                  <div className="flex gap-4 items-center">
                    <FileExtension title={asset.name} />
                    <span className="text-lg text-gray-600 font-medium">
                      {asset.name}
                    </span>
                  </div>

                  <div className="flex items-center">
                    <Spinner size={20} color="gray" />
                    <span className="ml-2 text-md">
                      Uploading... {asset.progress.toFixed(0)}%
                    </span>
                  </div>
                </div>
                <div className="mt-2 w-full bg-gray-200 rounded-full h-2.5">
                  <div
                    className="bg-blue-600 h-2.5 rounded-full transition-all duration-300"
                    style={{ width: `${asset.progress}%` }}
                  ></div>
                </div>
              </motion.div>
            ))}
          </AnimatePresence>
        </div>
      </div>
    </div>
  );
}

export default UploadProgress;
